/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AvailableIdentities } from './';
import {
    AvailableIdentitiesFromJSON,
    AvailableIdentitiesFromJSONTyped,
    AvailableIdentitiesToJSON,
} from './';
import type { ExtractedInformationFromSearchAndProfiles } from './';
import {
    ExtractedInformationFromSearchAndProfilesFromJSON,
    ExtractedInformationFromSearchAndProfilesFromJSONTyped,
    ExtractedInformationFromSearchAndProfilesToJSON,
} from './';
import type { FreelancerProfile } from './';
import {
    FreelancerProfileFromJSON,
    FreelancerProfileFromJSONTyped,
    FreelancerProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProposalInformationResponse
 */
export interface ProposalInformationResponse {
    /**
     * 
     * @type {AvailableIdentities}
     * @memberof ProposalInformationResponse
     */
    availableIdentities?: AvailableIdentities;
    /**
     * 
     * @type {Array<FreelancerProfile>}
     * @memberof ProposalInformationResponse
     */
    profiles: Array<FreelancerProfile>;
    /**
     * 
     * @type {ExtractedInformationFromSearchAndProfiles}
     * @memberof ProposalInformationResponse
     */
    extractedInformation?: ExtractedInformationFromSearchAndProfiles;
}

/**
 * Check if a given object implements the ProposalInformationResponse interface.
 */
export function instanceOfProposalInformationResponse(value: object): value is ProposalInformationResponse {
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function ProposalInformationResponseFromJSON(json: any): ProposalInformationResponse {
    return ProposalInformationResponseFromJSONTyped(json, false);
}

export function ProposalInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'availableIdentities': json['availableIdentities'] == null ? undefined : AvailableIdentitiesFromJSON(json['availableIdentities']),
        'profiles': ((json['profiles'] as Array<any>).map(FreelancerProfileFromJSON)),
        'extractedInformation': json['extractedInformation'] == null ? undefined : ExtractedInformationFromSearchAndProfilesFromJSON(json['extractedInformation']),
    };
}

export function ProposalInformationResponseToJSON(value?: ProposalInformationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'availableIdentities': AvailableIdentitiesToJSON(value['availableIdentities']),
        'profiles': ((value['profiles'] as Array<any>).map((v) => FreelancerProfileToJSON(v))),
        'extractedInformation': ExtractedInformationFromSearchAndProfilesToJSON(value['extractedInformation']),
    };
}

